export function getEnumValues<T extends Record<string, string | number>>(e: T): Array<T[keyof T]> {
    return Object.keys(e)
        .filter((q) => isNaN(Number(q)))
        .map((q) => e[q as keyof typeof e]);
}

export function convertEnumToStringOrNull(value: any) {
    if (value !== undefined && value !== null) {
        return value.toString();
    }
    return null;
}
